module.exports = __webpack_public_path__ + "miscusi_logo_mobile-n7k.svg";